import type { PrizeMiniEntity } from '@/features/prize/domain/entities/PrizeMiniEntity'

export class UpdateSpinWheelPrizesEntity {
  prizes?: PrizeMiniEntity[]
}
